var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdviceC(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 251,
    viewBox: "0 0 250 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M165.52 116.392L73.0701 63.1921V179.952L164.64 232.712L165.52 116.392Z",
    fill: "#B2E8C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M165.52 74.3122V116.392L73.0701 63.1922V24.4122L165.52 74.3122Z",
    fill: "#B2E8C5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M176.93 109.852L165.52 116.392V74.3122L73.0701 24.4122L87.6201 17.7322L176.93 67.0622V109.852Z",
    fill: "#72D09A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M176.93 109.852V223.582L164.64 232.712L165.52 116.392L176.93 109.852Z",
    fill: "#72D09A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M156.1 79.1422V101.322L82.48 59.2422V37.3422L156.1 79.1422Z",
    fill: "#29A063"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6501 83.1121V99.8921L80.8201 91.5921V75.6721L94.6501 83.1121Z",
    fill: "#F97E73"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8201 75.6721L83.3301 74.4221L96.3101 81.3121V99.0821L94.6501 99.8921V83.1121L80.8201 75.6721Z",
    fill: "#29A063"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M114.5 94.7922V111.572L100.68 103.272V87.3522L114.5 94.7922Z",
    fill: "#F97E73"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M100.68 87.3522L103.18 86.1022L116.17 92.9922V110.762L114.5 111.572V94.7922L100.68 87.3522Z",
    fill: "#29A063"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M114.5 116.412V133.192L100.68 124.902V108.972L114.5 116.412Z",
    fill: "#F97E73"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M100.68 108.972L103.18 107.722L116.17 114.612V132.382L114.5 133.192V116.412L100.68 108.972Z",
    fill: "#29A063"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M114.5 138.812V155.592L100.68 147.302V131.372L114.5 138.812Z",
    fill: "#F97E73"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M100.68 131.372L103.18 130.122L116.17 137.012V154.782L114.5 155.592V138.812L100.68 131.372Z",
    fill: "#29A063"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M114.5 160.532V177.312L100.68 169.022V153.092L114.5 160.532Z",
    fill: "#F97E73"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M100.68 153.092L103.18 151.852L116.17 158.742V176.512L114.5 177.312V160.532L100.68 153.092Z",
    fill: "#29A063"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M114.5 182.152V198.932L100.68 190.642V174.712L114.5 182.152Z",
    fill: "#F97E73"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M100.68 174.712L103.18 173.472L116.17 180.362V198.132L114.5 198.932V182.152L100.68 174.712Z",
    fill: "#29A063"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M134.49 128.282V145.062L120.66 136.772V120.842L134.49 128.282Z",
    fill: "#F97E73"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M120.66 120.842L123.16 119.602L136.15 126.492V144.262L134.49 145.062V128.282L120.66 120.842Z",
    fill: "#29A063"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M134.49 150.682V167.462L120.66 159.172V143.242L134.49 150.682Z",
    fill: "#F97E73"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M120.66 143.242L123.16 142.002L136.15 148.892V166.662L134.49 167.462V150.682L120.66 143.242Z",
    fill: "#29A063"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M134.49 172.412V189.192L120.66 180.892V164.972L134.49 172.412Z",
    fill: "#F97E73"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M120.66 164.972L123.16 163.722L136.15 170.612V188.382L134.49 189.192V172.412L120.66 164.972Z",
    fill: "#29A063"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M134.49 194.032V210.812L120.66 202.522V186.592L134.49 194.032Z",
    fill: "#F97E73"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M120.66 186.592L123.16 185.342L136.15 192.232V210.002L134.49 210.812V194.032L120.66 186.592Z",
    fill: "#29A063"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M154.55 139.082V155.862L140.73 147.572V131.642L154.55 139.082Z",
    fill: "#F97E73"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M140.73 131.642L143.23 130.392L156.22 137.282V155.062L154.55 155.862V139.082L140.73 131.642Z",
    fill: "#29A063"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M154.55 117.362V134.132L140.73 125.842V109.922L154.55 117.362Z",
    fill: "#F97E73"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M140.73 109.922L143.23 108.672L156.22 115.562V133.332L154.55 134.132V117.362L140.73 109.922Z",
    fill: "#29A063"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M134.39 106.222V123.002L120.56 114.702V98.7822L134.39 106.222Z",
    fill: "#F97E73"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M120.56 98.7822L123.07 97.5322L136.05 104.422V122.192L134.39 123.002V106.222L120.56 98.7822Z",
    fill: "#29A063"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M154.55 161.482V178.262L140.73 169.972V154.042L154.55 161.482Z",
    fill: "#F97E73"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M140.73 154.042L143.23 152.802L156.22 159.682V177.462L154.55 178.262V161.482L140.73 154.042Z",
    fill: "#29A063"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M154.55 183.212V199.982L140.73 191.692V175.772L154.55 183.212Z",
    fill: "#F97E73"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M140.73 175.772L143.23 174.522L156.22 181.412V199.182L154.55 199.982V183.212L140.73 175.772Z",
    fill: "#29A063"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M154.55 204.832V221.612L140.73 213.312V197.392L154.55 204.832Z",
    fill: "#F97E73"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M140.73 197.392L143.23 196.142L156.22 203.032V220.802L154.55 221.612V204.832L140.73 197.392Z",
    fill: "#29A063"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6501 104.772V121.552L80.8201 113.252V97.3322L94.6501 104.772Z",
    fill: "#F97E73"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8201 97.3322L83.3301 96.0822L96.3101 102.972V120.742L94.6501 121.552V104.772L80.8201 97.3322Z",
    fill: "#29A063"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6501 126.992V143.772L80.8201 135.482V119.552L94.6501 126.992Z",
    fill: "#F97E73"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8201 119.552L83.3301 118.302L96.3101 125.192V142.962L94.6501 143.772V126.992L80.8201 119.552Z",
    fill: "#29A063"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M94.65 149.822V186.432L81.23 179.062V142.402L94.65 149.822Z",
    fill: "#F97E73"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M81.23 142.402L83.33 140.522L96.3099 147.882V185.092L94.65 186.432V149.822L81.23 142.402Z",
    fill: "#29A063"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdviceC);
export default __webpack_public_path__ + "static/media/adviceC.59777cd265f85263911fdcae0aba9b22.svg";
export { ForwardRef as ReactComponent };